import { render } from "./authority.vue?vue&type=template&id=81f0d3ec"
import script from "./authority.vue?vue&type=script&lang=ts"
export * from "./authority.vue?vue&type=script&lang=ts"
script.render = render

export default script